// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { StorageServicePublicAccessSchema } from '../inputTypeSchemas/StorageServicePublicAccessSchema'
import { ScopeSchema } from '../inputTypeSchemas/ScopeSchema'
import { ExternalNetworkDiscoverySourceTypeSchema } from '../inputTypeSchemas/ExternalNetworkDiscoverySourceTypeSchema'

/////////////////////////////////////////
// STORAGE SERVICE SCHEMA
/////////////////////////////////////////

export const StorageServiceSchema = z.object({
  publicAccess: StorageServicePublicAccessSchema,
  scope: ScopeSchema,
  sourceType: ExternalNetworkDiscoverySourceTypeSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  name: z.string(),
  provider: z.string(),
  accountRef: z.string(),
  endpointHost: z.string(),
  resourceId: z.string(),
  region: z.string().nullable(),
  websiteEnabled: z.boolean(),
  cloudProvider: z.string().nullable(),
  cloudAccountRef: z.string().nullable(),
  cloudResourceId: z.string().nullable(),
  lastSeenAt: z.coerce.date().nullable(),
  postureCheckedAt: z.coerce.date().nullable(),
  deprovisionedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type StorageService = z.infer<typeof StorageServiceSchema>

export default StorageServiceSchema;
